const data = {
  id: 1,
  title: 'Match the sounds with the correct words',
  subTitle: 'Nối âm với từ tương ứng',
  question: '',
  answers: [
    { id: 1, answer: 'hippo', isCorrect: true, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/14655748-d1c2-401a-9e35-023422e5a9f9.mp3' },
    { id: 2, answer: 'bear', isCorrect: true, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/11c5fedf-cd9e-426b-810f-85aaba584272.mp3' },
    { id: 2, answer: 'crocodile', isCorrect: true, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/f95b3fd4-2c96-4df8-8f31-1dfe7acf6c72.mp3' },
  ],
};

export default data;
